// extracted by mini-css-extract-plugin
export var actionButton = "_9v-0";
export var attachmentLine = "_9v-1";
export var fileInput = "_9v-2";
export var fileUploadWrapper = "_9v-4";
export var footer = "_9v-3";
export var modalContent = "_9v-5";
export var paperclip = "_9v-6";
export var quillEditor = "_9v-7";